import {
  breadcrumbItemClasses,
  breadcrumbListClasses,
  breadcrumbSeparatorClasses,
  pageDescriptionClasses,
  pageHeaderActionsClasses,
  pageHeaderClasses,
  pageHeaderRowClasses,
  pageTitleClasses,
} from '@/shared/layout/page-header/styles';
import type { PageHeaderProps } from '@/shared/layout/page-header/types';

export function usePageHeaderProps({
  title,
  description,
  breadcrumbs = [],
  actions,
}: PageHeaderProps) {
  return {
    rootProps: { className: pageHeaderClasses },
    breadcrumbListProps: { className: breadcrumbListClasses, 'aria-label': 'Breadcrumb' },
    breadcrumbSeparatorProps: {
      className: breadcrumbSeparatorClasses,
      'aria-hidden': true,
    },
    breadcrumbs: breadcrumbs.map((crumb, index) => ({
      key: `${crumb.label}-${index}`,
      label: crumb.label,
      to: crumb.to,
      props: { className: breadcrumbItemClasses },
      isLast: index === breadcrumbs.length - 1,
    })),
    rowProps: { className: pageHeaderRowClasses },
    titleProps: { className: pageTitleClasses },
    title,
    descriptionProps: { className: pageDescriptionClasses },
    description,
    actionsProps: { className: pageHeaderActionsClasses },
    actions,
  };
}
